module.exports = __webpack_public_path__ + "static/media/12.ec622970.jpg";